import React, {useEffect }  from "react"
import {Grid, Paper} from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  ButtonTypeEnum, ButtonSizeEnum, SelfCheckinStepEnum
} from "components/shared/enums/global-enums.tsx";
import AppButton from "components/shared/AppButton/AppButton"
import useSelfCheckinNafigation from 'utils/useSelfCheckinNafigation';

import useStore from 'store/store'
import './TouchpointSelection.scss'


export default function TouchpointSelection(){
  const {t} = useTranslation();
  const storeActions = useStore((state)=> state.actions);
  const touchpoints = useStore((state)=> state.touchpoints);

  const [redirect,] = useSelfCheckinNafigation();

  useEffect(()=>{
    storeActions.fetchTouchpoints();
  }, [storeActions]);

  function selectTouchPoint(tp) {
    storeActions.storeItem("touchpoint", tp.location_id);
    storeActions.storeItem("touchpoint-label", tp.label);
    storeActions.storeItem("touchpoint-type", tp.type_device);
    redirect(0, SelfCheckinStepEnum.IDLE);
  }


  return (
    <div tabIndex="-1" className="sc-cover-bloc" >
      
        <Paper className="" sx={{p: 3}}>
          <div className="h4">
            {t("Select a touchpoint")}
          </div>
          <div className="v-space-5"></div>

          {
            touchpoints.map((tp, key)=>{
              return(
                <Grid key={key} container sx={{paddingBottom: 3}} spacing={5} >
                  <Grid item xs={3}>{tp.label}</Grid>
                  <Grid item xs={5}>{tp.location_id}</Grid>
                  <Grid item xs={2}>{tp.type_device}</Grid>
                  <Grid item xs={2}>
                      
                    <AppButton 
                      onClickFunc={()=>selectTouchPoint(tp)}
                      sx={{marginLeft:3}}
                      buttonLabel={ t("Select")}
                      buttonType={ButtonTypeEnum.PRIMARY}
                      buttonSize={ButtonSizeEnum.SMALL}
                    />

                  </Grid>
                </Grid>
                )
            })
          }
        </Paper>
    </div>
    )
}